// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Index_layoutContainer__khyUc","cardContainer":"Index_cardContainer__cS+kh"};